import script from "./ClipboardWindow.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClipboardWindow.vue?vue&type=script&setup=true&lang=ts"

import "./ClipboardWindow.vue?vue&type=style&index=0&id=a0544c18&scoped=true&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0544c18"]])

export default __exports__